/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TeamRouteImport } from './routes/team'
import { Route as InvitationsRouteImport } from './routes/invitations'
import { Route as GenerateRouteImport } from './routes/generate'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TestAssignmentIdRouteImport } from './routes/test.$assignmentId'
import { Route as SearchesNewRouteImport } from './routes/searches.new'
import { Route as SearchesSearchIdRouteImport } from './routes/searches.$searchId'
import { Route as InvitationsAssignmentIdRouteImport } from './routes/invitations_.$assignmentId'
import { Route as ClientsNewRouteImport } from './routes/clients_.new'
import { Route as ClientsClientIdRouteImport } from './routes/clients_.$clientId'
import { Route as ApplySearchIdRouteImport } from './routes/apply.$searchId'

const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsRoute = InvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => rootRouteImport,
} as any)
const GenerateRoute = GenerateRouteImport.update({
  id: '/generate',
  path: '/generate',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestAssignmentIdRoute = TestAssignmentIdRouteImport.update({
  id: '/test/$assignmentId',
  path: '/test/$assignmentId',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchesNewRoute = SearchesNewRouteImport.update({
  id: '/searches/new',
  path: '/searches/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchesSearchIdRoute = SearchesSearchIdRouteImport.update({
  id: '/searches/$searchId',
  path: '/searches/$searchId',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsAssignmentIdRoute = InvitationsAssignmentIdRouteImport.update({
  id: '/invitations_/$assignmentId',
  path: '/invitations/$assignmentId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsNewRoute = ClientsNewRouteImport.update({
  id: '/clients_/new',
  path: '/clients/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/clients_/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplySearchIdRoute = ApplySearchIdRouteImport.update({
  id: '/apply/$searchId',
  path: '/apply/$searchId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/clients': typeof ClientsRoute
  '/generate': typeof GenerateRoute
  '/invitations': typeof InvitationsRoute
  '/team': typeof TeamRoute
  '/apply/$searchId': typeof ApplySearchIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/clients/new': typeof ClientsNewRoute
  '/invitations/$assignmentId': typeof InvitationsAssignmentIdRoute
  '/searches/$searchId': typeof SearchesSearchIdRoute
  '/searches/new': typeof SearchesNewRoute
  '/test/$assignmentId': typeof TestAssignmentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/clients': typeof ClientsRoute
  '/generate': typeof GenerateRoute
  '/invitations': typeof InvitationsRoute
  '/team': typeof TeamRoute
  '/apply/$searchId': typeof ApplySearchIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/clients/new': typeof ClientsNewRoute
  '/invitations/$assignmentId': typeof InvitationsAssignmentIdRoute
  '/searches/$searchId': typeof SearchesSearchIdRoute
  '/searches/new': typeof SearchesNewRoute
  '/test/$assignmentId': typeof TestAssignmentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/clients': typeof ClientsRoute
  '/generate': typeof GenerateRoute
  '/invitations': typeof InvitationsRoute
  '/team': typeof TeamRoute
  '/apply/$searchId': typeof ApplySearchIdRoute
  '/clients_/$clientId': typeof ClientsClientIdRoute
  '/clients_/new': typeof ClientsNewRoute
  '/invitations_/$assignmentId': typeof InvitationsAssignmentIdRoute
  '/searches/$searchId': typeof SearchesSearchIdRoute
  '/searches/new': typeof SearchesNewRoute
  '/test/$assignmentId': typeof TestAssignmentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/clients'
    | '/generate'
    | '/invitations'
    | '/team'
    | '/apply/$searchId'
    | '/clients/$clientId'
    | '/clients/new'
    | '/invitations/$assignmentId'
    | '/searches/$searchId'
    | '/searches/new'
    | '/test/$assignmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/clients'
    | '/generate'
    | '/invitations'
    | '/team'
    | '/apply/$searchId'
    | '/clients/$clientId'
    | '/clients/new'
    | '/invitations/$assignmentId'
    | '/searches/$searchId'
    | '/searches/new'
    | '/test/$assignmentId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/clients'
    | '/generate'
    | '/invitations'
    | '/team'
    | '/apply/$searchId'
    | '/clients_/$clientId'
    | '/clients_/new'
    | '/invitations_/$assignmentId'
    | '/searches/$searchId'
    | '/searches/new'
    | '/test/$assignmentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  ClientsRoute: typeof ClientsRoute
  GenerateRoute: typeof GenerateRoute
  InvitationsRoute: typeof InvitationsRoute
  TeamRoute: typeof TeamRoute
  ApplySearchIdRoute: typeof ApplySearchIdRoute
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  ClientsNewRoute: typeof ClientsNewRoute
  InvitationsAssignmentIdRoute: typeof InvitationsAssignmentIdRoute
  SearchesSearchIdRoute: typeof SearchesSearchIdRoute
  SearchesNewRoute: typeof SearchesNewRoute
  TestAssignmentIdRoute: typeof TestAssignmentIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations': {
      id: '/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof InvitationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/generate': {
      id: '/generate'
      path: '/generate'
      fullPath: '/generate'
      preLoaderRoute: typeof GenerateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/$assignmentId': {
      id: '/test/$assignmentId'
      path: '/test/$assignmentId'
      fullPath: '/test/$assignmentId'
      preLoaderRoute: typeof TestAssignmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/searches/new': {
      id: '/searches/new'
      path: '/searches/new'
      fullPath: '/searches/new'
      preLoaderRoute: typeof SearchesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/searches/$searchId': {
      id: '/searches/$searchId'
      path: '/searches/$searchId'
      fullPath: '/searches/$searchId'
      preLoaderRoute: typeof SearchesSearchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations_/$assignmentId': {
      id: '/invitations_/$assignmentId'
      path: '/invitations/$assignmentId'
      fullPath: '/invitations/$assignmentId'
      preLoaderRoute: typeof InvitationsAssignmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients_/new': {
      id: '/clients_/new'
      path: '/clients/new'
      fullPath: '/clients/new'
      preLoaderRoute: typeof ClientsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients_/$clientId': {
      id: '/clients_/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/$searchId': {
      id: '/apply/$searchId'
      path: '/apply/$searchId'
      fullPath: '/apply/$searchId'
      preLoaderRoute: typeof ApplySearchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  ClientsRoute: ClientsRoute,
  GenerateRoute: GenerateRoute,
  InvitationsRoute: InvitationsRoute,
  TeamRoute: TeamRoute,
  ApplySearchIdRoute: ApplySearchIdRoute,
  ClientsClientIdRoute: ClientsClientIdRoute,
  ClientsNewRoute: ClientsNewRoute,
  InvitationsAssignmentIdRoute: InvitationsAssignmentIdRoute,
  SearchesSearchIdRoute: SearchesSearchIdRoute,
  SearchesNewRoute: SearchesNewRoute,
  TestAssignmentIdRoute: TestAssignmentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
